import type { FileMetaData } from 'Asset/components/asset/Operations/AssetPostUploadForm'
import { Asset } from 'Asset/utils/assetTypes'
import { Operation } from 'fast-json-patch'

import { servicesAsync } from 'Common/environment/environment'
import {
    fetchDelete,
    fetchGet,
    fetchGetBlob,
    fetchPatch,
    fetchPostFile,
    fetchPutFile,
} from 'Common/utils/query/request'

const baseUrl = servicesAsync.assets('')

interface AssetPatch {
    id: number
    patchSet: Operation[]
}

interface AssetPostRequest {
    assetTypeId: string
    publishingHouseId: string
    file: File
    fileMetaData?: FileMetaData
}

interface AssetPutRequest {
    id: number
    file: File
}

export const assetGet = async (assetId: number) => {
    const response = await fetchGet(`${await baseUrl}/v1/assets/${assetId}`)
    return response as Asset
}

export const assetDelete = async (assetId: number) => {
    return await fetchDelete(`${await baseUrl}/v1/assets/${assetId}`)
}

export const assetGetThumbnail = async (id: number, maxWidth: number = 280) => {
    const response = await fetchGetBlob(`${await baseUrl}/v1/thumbs/${id}?maxWidth=${maxWidth}`)
    const thumbnailUri = URL.createObjectURL(await response.blob())
    return thumbnailUri
}

export const assetPost = async (data: AssetPostRequest) => {
    const formData = new FormData()
    formData.append(
        'contract',
        JSON.stringify({
            assetType: { id: data.assetTypeId },
            publishingHouse: { id: data.publishingHouseId },
            description: data.file.name,
            keywords: data.fileMetaData?.keywords,
            contractType: data.fileMetaData?.contractType?.id
                ? data.fileMetaData.contractType
                : null,
            contractDate: data.fileMetaData?.contractDate,
        }),
    )

    formData.append('file', data.file)
    return (await fetchPostFile(`${await baseUrl}/v1/assets`, formData)) as Asset[]
}

export const assetPut = async (data: AssetPutRequest) => {
    const formData = new FormData()
    formData.append('file', data.file)
    return await fetchPutFile(`${await baseUrl}/v1/assets/${data.id}/file`, formData)
}

export const assetPatch = async (request: AssetPatch) => {
    const response = await fetchPatch(
        `${await baseUrl}/v1/assets/${request.id}`,
        JSON.stringify(request.patchSet),
    )
    return response as Asset
}
